export default {
  nav: {
    brandProducts: 'Produits Positive', discover: 'Découvrir', allProducts: 'Tous les produits',
    otherProducts: 'Autres produits : {count}',
    connectedApps: 'Apps connectées', currentProduct: 'Vous êtes dans {product}',
    openApp: 'Ouvrir {product} dans un nouvel onglet', discoverProduct: 'Découvrir {product}',
  },
  actions: {
    tryFree: 'Essayer gratuitement', discover: 'Découvrir', discoverProduct: 'Découvrir {product}',
    backToCatalog: 'Retour à tous les produits',
    signIn: 'Connectez-vous', close: 'Fermer',
  },
  agent: {
    useAssistant: 'Utiliser dans votre assistant IA', title: 'Utilisez {product} dans votre assistant IA',
    description: 'Connectez votre assistant à {product} grâce à son serveur MCP.',
    other: 'Autre',
    copyPrompt: 'Copier le prompt',
    copyDone: 'Copié', copyRetry: 'Réessayer',
    connectTitle: 'Choisir votre assistant', connect: 'Connecter', availableFor: 'Disponible pour {product}',
    connectionHint: 'Vous devrez peut-être vous connecter et autoriser l’accès.',
    permissions: 'Votre assistant accède uniquement aux données et actions que vous autorisez.',
    copy: 'Copier le prompt de connexion de votre agent à {product}',
    copied: 'Prompt copié. Collez-le dans votre agent.', copyError: 'Impossible de copier le prompt. Veuillez réessayer.',
  },
  catalog: {
    title: 'Découvrez les produits Positive', description: 'Des outils complémentaires à {product}.',
    descriptionDefault: 'Des outils pour vos équipes marketing et commerciales.', empty: 'Aucun produit à découvrir.',
  },
  product: { featuresTitle: 'Ce que vous pouvez faire avec {product}' },
  status: { current: 'App courante', connected: 'App connectée' },
  accessibility: { openMenu: 'Ouvrir la navigation produits', newTab: 'S’ouvre dans un nouvel onglet' },
  categories: { emailSignatures: 'Signatures email', emailing: 'Emailing', seo: 'SEO & GEO', socialMedia: 'Réseaux sociaux', sales: 'Ventes' },
  products: {
    signitic: {
      tagline: 'Gestion des signatures email',
      description: 'Centralisez toutes les signatures email et faites-en un canal marketing.',
      features: ['Une signature harmonisée dans toute l’entreprise', 'Des campagnes de bannières dans chaque email', 'Analyse des clics et de la portée'],
    },
    user: {
      tagline: 'Emailing et engagement client',
      description: 'Automatisation, CRM et chat en direct pour engager vos contacts au bon moment.',
      features: ['Des parcours email et SMS automatisés', 'Un CRM pour vos contacts et vos opportunités', 'Un chat en direct sur votre site'],
    },
    surfer: {
      tagline: 'Optimisation des contenus SEO et GEO',
      description: 'Rédigez des contenus bien positionnés sur Google et cités par les assistants IA.',
      features: ['Des briefs de contenu pour mieux se positionner sur Google', 'Des citations dans ChatGPT et les réponses IA', 'Rédaction d’articles par IA'],
    },
    iconosquare: {
      tagline: 'Gestion et analyse des réseaux sociaux',
      description: 'Planifiez, répondez et mesurez les performances de vos réseaux sociaux depuis une seule plateforme.',
      features: ['Planification des publications sur chaque réseau', 'Une boîte de réception pour les commentaires et messages privés', 'Analyses et rapports'],
    },
    humanlinker: {
      tagline: 'Copilote commercial IA',
      description: 'Approchez chaque prospect de façon personnalisée et transformez vos conversations en ventes.',
      features: ['Recommandations de prospects par IA', 'Séquences de prospection personnalisées', 'Préparation des rendez-vous en un clic'],
    },
    ubic: {
      tagline: 'Appels en parallèle pour les équipes commerciales',
      description: 'Un outil d’appels en parallèle pour joindre davantage de prospects en moins de temps.',
      features: ['Appelez plusieurs prospects simultanément', 'Seuls les appels décrochés vous sont transférés', 'Synchronisation avec votre CRM'],
    },
    nocrm: {
      tagline: 'Gestion des prospects pour les commerciaux',
      description: 'Suivez chaque prospect du premier contact à la vente, sans la complexité d’un CRM.',
      features: ['Tous vos prospects dans un même pipeline', 'Des rappels pour ne manquer aucune opportunité', 'Une application mobile pour le terrain'],
    },
  },
};
